/*
* @Author: zyc
* @Date:   2016-09-11 23:36:05
* @Last Modified by:   unrealce
* @Last Modified time: 2016-09-13 01:26:13
*/
'use strict';

var crypto = require('crypto');

var base58 = require('bs58');

module.exports.encode = function (data) {
  var prefix = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '00';
  var encoding = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'hex';

  if (typeof data === 'string') {
    data = new Buffer(data, encoding);
  }

  if (!(data instanceof Buffer)) {
    throw new TypeError('"data" argument must be an Array of Buffers');
  }

  if (!(prefix instanceof Buffer)) {
    prefix = new Buffer(prefix, encoding);
  }

  var hash = Buffer.concat([prefix, data]);
  hash = crypto.createHash('sha256').update(hash).digest();
  hash = crypto.createHash('sha256').update(hash).digest();
  hash = Buffer.concat([prefix, data, hash.slice(0, 4)]);
  return base58.encode(hash);
};

module.exports.decode = function (string, encoding) {
  var buffer = new Buffer(base58.decode(string));
  var prefix = buffer.slice(0, 1);
  var data = buffer.slice(1, -4);
  var hash = Buffer.concat([prefix, data]);
  hash = crypto.createHash('sha256').update(hash).digest();
  hash = crypto.createHash('sha256').update(hash).digest();
  buffer.slice(-4).forEach(function (check, index) {
    if (check !== hash[index]) {
      throw new Error('Invalid checksum');
    }
  });

  if (encoding) {
    prefix = prefix.toString(encoding);
    data = data.toString(encoding);
  }

  return {
    prefix: prefix,
    data: data
  };
};